import InventoryOverview from "../../../components/inventory-overview";
export default function InventoryPage() {
	return <InventoryOverview linkLocale="en" />;
}
